/* @kdd-custom — C1 le standard de la maison (page contact/SAV).
   1. L'état vivant : le serveur écrit les horaires (toujours vrais) ; ici on
      les remplace par la phrase calculée à l'heure de Paris, sous
      [data-kdd-etat-actif] uniquement. Sans JS : horaires affichés, pas de
      diode.
   2. Les touches de sujet : préfixent le message (champ caché
      contact[Sujet]), affichent la réponse immédiate, montrent/masquent le
      champ n° de commande. Sans JS : touches inertes, tous les champs
      visibles, le formulaire marche. */
(function () {
  function phraseEtat() {
    var paris = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
    var j = paris.getDay();
    var h = paris.getHours();
    var ouvert = j >= 1 && j <= 5 && h >= 9 && h < 17;
    if (ouvert) return { etat: 'ouvert', txt: 'Ouvert, on vous répond aujourd’hui (9 h à 17 h)' };
    if (j >= 1 && j <= 5 && h < 9) return { etat: 'ferme', txt: 'Fermé, nous vous répondons aujourd’hui dès 9 h' };
    if (j >= 1 && j <= 4) return { etat: 'ferme', txt: 'Fermé, nous vous répondons demain dès 9 h' };
    if (j === 0) return { etat: 'ferme', txt: 'Fermé, nous vous répondons demain dès 9 h' };
    /* vendredi soir ou samedi */
    return { etat: 'ferme', txt: 'Fermé, nous vous répondons lundi dès 9 h' };
  }

  function initEtat() {
    var els = document.querySelectorAll('[data-kdd-etat]:not([data-kdd-etat-actif])');
    if (!els.length) return;
    var e;
    try { e = phraseEtat(); } catch (err) { return; }
    els.forEach(function (el) {
      el.setAttribute('data-kdd-etat-actif', e.etat);
      el.textContent = e.txt;
    });
  }

  function initTouches() {
    var racine = document.querySelector('[data-kdd-sav]');
    if (!racine || racine.hasAttribute('data-kdd-sav-actif')) return;
    var touches = racine.querySelectorAll('.kdd-ct__touche');
    if (!touches.length) return;
    var hint = racine.querySelector('[data-kdd-hint-cible]');
    var champSujet = racine.querySelector('[data-kdd-sujet-champ]');
    var champCmd = racine.querySelector('[data-kdd-champ-cmd]');
    racine.setAttribute('data-kdd-sav-actif', '');

    function applique(t) {
      touches.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      if (hint) hint.textContent = t.getAttribute('data-kdd-hint') || '';
      if (champSujet) champSujet.value = (t.getAttribute('data-kdd-sujet') || '').replace('&amp;', '&');
      if (champCmd) champCmd.style.display = t.getAttribute('data-kdd-cmd') === 'oui' ? '' : 'none';
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'contact_sujet', sujet: champSujet ? champSujet.value : '' });
      } catch (e) {}
    }
    touches.forEach(function (t) {
      t.addEventListener('click', function () { applique(t); });
    });
    applique(touches[0]);
  }

  function init() { initEtat(); initTouches(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
